import React, {useEffect, useState} from "react";
import axios from "axios";
import {Enum} from "./objects/Enum";
import {useAuth} from "../useAuth";
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const objectsGridEnumsUrl = process.env.REACT_APP_OBJECTS_GRID_BASE_URL + '/enums/';

const Enums = () => {

    const {ogToken, ogAccessPoint} = useAuth();

    const [showCurlDialog, setShowCurlDialog] = useState(false);
    const [enums, setEnums] = useState(null);

    useEffect(() => {
        fetchObjects();
    }, [])

    const createEnum = async () => {

        const newEnum: Enum = {
            id: "FirstEnum",
            description: 'This is an example enum created via the API',
            values: [
                { key: 'key1', val: "value1", order: 1},
                { key: 'key2', val: "value2", order: 2},
                { key: 'key3', val: "value3", order: 3},
            ]
        };

        return axios.post(objectsGridEnumsUrl,
            newEnum,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`
                }
            }).then(response => {
            console.log('Response from OG API:', response.data);
        }).catch(error => console.error('Adding Enum failed:', error));

    }

    const fetchObjects = async () => {

        return axios.get(objectsGridEnumsUrl + "?from=0&size=1000",
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`
                }
            }).then(response => {
            console.log('Response from getEnums: ', response.data);
            setEnums(response.data);
        }).catch(error => console.error('Getting enums failed:', error));
    };

    const genericObjectsCurlDialogHeader = (options: { className: any; }) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold text-lg">Enums</span>
                </div>
                <div>
                    <Button
                        icon="pi pi-code"
                        label="Show cURL"
                        onClick={() => setShowCurlDialog(true)}
                    />
                </div>
            </div>
        );
    };

    return (
        <div>
            <Panel headerTemplate={genericObjectsCurlDialogHeader}>
                <Button
                    label="Create GenericObject"
                    icon="pi pi-plus"
                    className="mb-2 mr-2"
                    onClick={() => createEnum()}
                />

                <div className="datatable-container">
                    <DataTable value={enums!}
                               paginator
                               stripedRows
                               rows={100}>
                        <Column field="id" header="ID"/>
                        <Column field="description" header="Description"/>
                    </DataTable>
                </div>
            </Panel>
        </div>);

};

export default Enums;
